module.exports = __webpack_public_path__ + "img/electricMotorcycle-orange.d2e7121e.svg";